var map = {
	"./main_logo.png": "yy6E",
	"./main_logo_white.png": "EFYr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yWGf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cereshop/home ^\.\/main_logo.*\.png$
// module id = yWGf
// module chunks = 18